module.exports = __webpack_public_path__ + "static/media/gd_dsc_lockup_vertical_color.593baf43.png";